import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { ContextOrderBasketType } from "../../hooks";

export const getProductStockToDisplay = (
  product: { id: number; availableStock: number },
  order?: ContextOrderBasketType | null,
  submittedOrder?: OrderGetResponseType,
) => {
  // If this is a new order, return actual stock
  if (!order || !submittedOrder) return product.availableStock;

  // If editing a pending order, return actual stock + submitted order quantity
  return (
    product.availableStock +
    (submittedOrder.id
      ? (submittedOrder.OrderItems || []).find(
          (i) => (i.ProductId || i.Product.id) === product.id,
        )?.quantity || 0
      : 0)
  );
};
